export default __webpack_public_path__ + "7fd218e6078229db095173c432602f67.png";